<template>
  <v-flex>
    <v-layout row wrap>
      <v-flex xs12>
        <h2 class="primary--text pb-2">Account Details</h2>
        <p>Change the name of the account.</p>
      </v-flex>
      <v-flex xs12 sm6 :class="{'pr-0 pb-4 mt-3': $vuetify.breakpoint.smAndDown, 'mt-3 pr-4 pb-0': $vuetify.breakpoint.mdAndUp}">
        <v-text-field v-model="account.title" label="Title" box></v-text-field>
        <v-text-field v-model="account.nickname" label="Nickname" box></v-text-field>
        <v-autocomplete
          box
          :items="timezones"
          v-model="account.timezone"
          label="Timezone"
          no-data-text="No timezones found"
          append-icon="keyboard_arrow_down"
          @change="$emit('update-account-data', {key: 'changedTimezone', value: account.timezone})">
        </v-autocomplete>
        <v-autocomplete
          box
          :items="teams"
          item-text="displayName"
          item-value="id"
          v-model="selectedDefaultTeamId"
          label="Default team"
          hint="New users join this team. Selecting a team makes it the default."
          persistent-hint
          no-data-text="No teams found"
          append-icon="keyboard_arrow_down"
          @change="defaultTeamChanged">
        </v-autocomplete>
        <v-text-field
          v-if="isAppAdmin"
          v-model="account.adminConsoleToken"
          label="Admin Console Token"
          box
          @change="$emit('update-account-data', {key: 'changedAdminConsoleToken', value: account.adminConsoleToken})">
        </v-text-field>
      </v-flex>
      <!-- Menu Colour and logo hidden until functional -->
      <v-flex v-if="false" xs12>
       <h2 class="mt-4 mb-1">Menu colour</h2>
        <v-switch class="mt-3" color="secondary" label="White menu" v-model="computedWhiteTheme"></v-switch>
         <v-flex mb-4 v-if="computedWhiteTheme  && customLogoEnabled">
          <h2 class="mt-2 mb-1">Upload a logo for the white menu.</h2>
          <p><i>Width 318px; Height 50px.</i></p>
          <v-btn color="secondary" class="ml-0 mt-0 white--text">Upload logo<v-icon right dark>file_upload</v-icon></v-btn>
        </v-flex>
        <v-flex v-if="customColorEnabled">
          <v-switch class="mt-0" color="secondary" label="Custom menu colour" v-model="customColor"></v-switch>
        </v-flex>
        <v-flex v-if="customColor && !computedWhiteTheme">
          <verte class="mt-1 mb-1" v-model="computedMenuColor" :model="rgb" menuPosition="top" picker="square"></verte><h3 class="d-inline-block">{{menuColor}}</h3>
          <p class="mt-1 mb-0">Click swatch above to open color picker.</p><p><span class="font-weight-bold d-inline-bold">NB:</span> It needs to be dark enough for white text to be legible!</p>
        </v-flex>
        <v-flex v-if="customColor && !computedWhiteTheme && customLogoEnabled">
            <h2 class="mt-4 mb-1">Upload a logo for your brand colour menu.</h2>
            <p><i>Width 318px. Height 50px. Your logo should be an SVG or transparent PNG with no background. </i></p>
            <v-btn color="secondary" class="ml-0 mb-2 mt-0 white--text">Upload logo<v-icon right dark>file_upload</v-icon></v-btn>
        </v-flex>

        <h2 class="mt-4 mb-1">Upload a logo for your login screen</h2>
        <p><i>Width 318px; Height can vary but don't make too tall.</i></p>
        <v-btn v-if="!logoUrl" color="secondary" class="ml-0 mt-0 white--text">Upload logo<v-icon right dark>file_upload</v-icon></v-btn>
        <div v-if="logoUrl" class="custom-logo-wrapper p-relative mt-3"><!-- Shown when logo uploaded. Upload button removed -->
        <img class="custom-logo" :src="logoUrl"/><!-- Image width is 318px.-->
          <v-icon class="custom-logo-clear" color="error">cancel</v-icon>
        </div>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import Timezones from './timezones.js'
import { mapState } from 'vuex'

export default {
  name: "account-details",
  props: ["account"],
  data: () => ({
    rgb: '',
    customColor: false,
    customLogoEnabled: false,
    customColorEnabled: true,
    logoUrl: "",
    selectedDefaultTeamId: null
  }),
  watch: {
    account: {
      immediate: true,
      handler() {
        this.syncDefaultTeam()
      }
    },
    customColor() {
      if (this.computedWhiteTheme && this.customColor) { this.computedWhiteTheme = false }
    },
    whiteTheme() {
      if (this.computedWhiteTheme && this.customColor) { this.customColor = false }
    }
  },
  computed: {
    ...mapState({
      menuColor: state => state.ui.menuColor,
      whiteTheme: state => state.ui.whiteTheme,
      currentUser: state => state.currentUser.me,
      teams: state => (state.teams && state.teams.all) ? state.teams.all : []
    }),
    isAppAdmin() { return this.currentUser && this.currentUser.isAppAdmin },
    computedMenuColor: {
      get() {
        return this.menuColor
      },
      set(color) {
        this.$store.dispatch('updateMenuColor', color)
      }
    },
    computedWhiteTheme: {
      get() {
        return this.whiteTheme
      },
      set(theme) {
        this.$store.dispatch('updateWhiteTheme', theme)
      }
    },
    timezones() { return Timezones.canonical }
  },
  methods: {
    syncDefaultTeam() {
      const team = this.account && this.account.defaultTeam
      this.selectedDefaultTeamId = team && team.id ? team.id : null
    },
    defaultTeamChanged(teamId) {
      this.$emit("update-account-data", { key: "changedDefaultTeamId", value: teamId })
    }
  }
}
</script>

<style>
  .verte {
    width:40px;
    display:inline-block !important;
    vertical-align:middle;
  }

  .verte__guide {
    border-radius:50%;
    -webkit-box-shadow: 0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12);
    box-shadow: 0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12);
  }

  .custom-logo-wrapper {
    width:100%;
    max-width:352px;
    display:block;
    padding-right:34px;
  }

  .custom-logo {
    width:100%;
    max-width:318px;
  }

  .custom-logo-clear {
    position:absolute;
    right:0;
    top:50%;
    margin-top:-10px;
  }

</style>
